import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { CompanyNews } from "src/app/models/company-news";
import { UrlConstants } from "src/app/models/urlConstants";

@Component({
  selector: "app-news-details-modal",
  templateUrl: "./news-details-modal.component.html",
  styleUrls: ["./news-details-modal.component.scss"],
})
export class NewsDetailsModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService
  ) { }


  new: CompanyNews;

  ngOnInit() {
    this.new = this.data.item;
  }

  getColor(item) {
    switch (item) {
      case 1:
        return {
          background: "aquamarine",
          color: "black",
        };
      case 2:
        return {
          background: "bisque",
          color: "black",
        };
      case 3:
        return {
          background: "teal",
          color: "whitesmoke",
        };
      case 4:
        return {
          background: "greenyellow",
          color: "black",
        };
      case 5:
        return {
          background: "cornflowerblue",
          color: "black",
        };
      case 6:
        return {
          background: "darkorange",
          color: "black",
        };
      case 7:
        return {
          background: "darkslategrey",
          color: "white",
        };
      case 8:
        return {
          background: "yellow",
          color: "black",
        };
      case 9:
        return {
          background: "violet",
          color: "white",
        };
      case 12: {
        return {
          background: "lightcoral",
          color: "whitesmoke",
        };
      }
      default: {
        return {
          background: "lightgray",
          color: "black",
        };
      }
    }
  }

  openAttachment(url) {
    window.open(UrlConstants.egxUrl + url)
  }
}
